import React, { useState, useEffect, useContext } from 'react';
import { createMuiTheme, Container, CssBaseline, Toolbar, IconButton, Typography, FormControlLabel, Checkbox, Backdrop, CircularProgress, Fab, Grid, AppBar } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { HttpService } from "../../../apiAuthorization/httpService";
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);

export default function UserSettingMenu(props) {
    const { theme } = useContext(Theme);
    const classes = useStyles();
    const userName = props.model.length === 0 ? "" : props.model.userName;
    const [userSettings, setUserSettings] = useState([]);
    const [checked, setChecked] = useState([]);
    const [backDrop, setBackDrop] = useState(true);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const closeUserSettings = () => {
        props.parentCallback();
    };

    const saveUserSettings = (item, checked) => {
        setBackDrop(true);
        item.Checked = checked;
        HttpService.post('/User/SaveAppSettingMenuForUser', {
            AppModuleGroupId: item.AppModuleGroupId,
            AppSettingMenuId: item.AppSettingMenuId,
            AppUserName: userName,
            Checked: item.Checked,
            IsDeleted: item.IsDeleted,
            SettingName: item.SettingName,
            Source: item.Source
        })
        .then((result) => {
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    const getUserSettings = () => {
        HttpService.post('/User/GetAppSettingMenuWithUser', { AppUserName: userName })
        .then((result) => {
            setUserSettings(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getUserSettings();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="userSettingsBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={closeUserSettings} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>User Settings</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={closeUserSettings}>
                                        <CloseIcon />
                                    </Fab>
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <div className="react-bootstrap-table" style={{ overflowY: "auto", scrollBehavior: "smooth", position: "absolute", top: "15px", bottom: "15px", left: "15px", right: "15px" }}>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}></th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, }}>Name</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-capitalize">
                                            {userSettings?.map((item, index) => (
                                                <tr key={item.AppSettingMenuId}>
                                                    <td style={rowStyle(index)}>{index + 1}</td>
                                                    <td style={rowStyle(index)}>
                                                        <FormControlLabel
                                                            label=""
                                                            control={
                                                                <Checkbox
                                                                    name={"chk" + item.AppSettingMenuId}
                                                                    checked={item.Checked}
                                                                    onChange={(e) => setChecked({ ...checked, [e.target.name]: e.target.checked })}
                                                                    onClick={e => saveUserSettings(item, e.target.checked)}
                                                                    color="primary"
                                                                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                                                                />
                                                            }                                                        
                                                        />
                                                    </td>
                                                    <td style={rowStyle(index)}>{item.SettingName}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
